export default __webpack_public_path__ + "static/media/pi.ded28749.png";